/**
 * created by li si yi
 * 内容安全中心-详情页
 */
import React, {Component} from 'react';
import {Empty, message} from "antd";
import BaseComponent from "../../../base/BaseComponent";
import noFileIcon from '../img/icon_noFile_1.png'
import '../components/details.css'
import {HistoryList} from "../../editor/staticButton/history/history";
import moment from "moment";
import $jq from "jquery"
import {Scrollbars} from "react-custom-scrollbars";
import $ from 'jquery';
import {DetailDialog} from "../../resource/view/dialog/video/video";

let extIconList = {
    pdfs: {
        ext: ['pdf'],
        icon: '',
    },
    words: {
        ext: ['docx', 'doc'],
        icon: '',
    },
    zips: {
        ext: ['rar', 'zip', 'tar', 'gz', '7z', 'bz2', 'cab'],
        icon: '',
    },
    excels: {
        ext: ['xlsx', 'xls'],
        icon: '',
    },
    videos: {
        ext: ['avi', 'mp4', 'mov', 'mkv', 'rmvb', 'flv', 'rm', 'mpeg', 'mpg', 'ogv', 'wmv', 'webm'],
        getIconFun: 'videoIcon'
    },
    audios: {
        ext: ["mp3", "ogg", "webm", "wav", "mid"],
        icon: '',
    },
    imgs: {
        ext: ["jpg", "jpeg", "gif", "png", "bmp", "webp", "webp2", "tiff", "tif"],
        getIconFun: 'imgIcon'
    },
    ppts: {
        ext: ['pptx', 'ppt'],
        icon: '',
    },
    txts: {
        ext: ['txt', 'md', 'xml'],
        icon: '',
    },
    default: {
        ext: [],
        icon: noFileIcon
    }
};
export default class Details extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            checkUrl: "",
            mainBody: {// 正文
                content: "",
                title: "",
                ftitle: "",
                summary: "",
            },
            list: [],
            attach: [],// 附件
            downloadFileData: [],
            checkAllWord: [],// 敏感词
            dataType: '',//类型
            videoPath:''
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
        // 获取内容
        if (this.urlParams) {
            if (this.urlParams && this.urlParams.checkUrl) {
                this.state.checkUrl = this.urlParams.checkUrl.check_info_url;
                // console.log('this.state.checkUrl', this.state.checkUrl);
                if (this.state.checkUrl && this.state.checkUrl.indexOf('story') > -1) {
                    this.state.dataType = 'story'
                } else if (this.state.checkUrl && this.state.checkUrl.indexOf('WebNews') > -1) {
                    this.state.dataType = 'WebNews'
                }
            }
            if (this.state.dataType !== 'material' && this.urlParams && this.urlParams.checkAll && this.urlParams.checkAll.key) {
                this.getItemDataSource(this.urlParams.checkAll.key);
                // this.getContent();
                // console.log('this.urlParams.checkUrl.id', this.urlParams.checkUrl.id);
                // 获取历史记录
                this.getHistoryData(this.urlParams?.checkUrl?.id);
                this.iconConfig();
            }
        }

    }

    render() {
        return (
            <div>
                {this.renderContent()}
                {this.renderLeft()}
                {this.renderRight()}
                <DetailDialog ref={e => this.detailDialog = e} path={this.state.videoPath}/>
            </div>
        )
    }

    // 内容部分
    renderContent = () => {
        let {checkAllWord} = this.state;
        const height = window.innerHeight - 24 - 20;
        const publicStyle = {
            fontWeight: '400',
            marginBottom: '24px'
        };
        let content = this.state.mainBody.content;
        let title = this.state.mainBody.title;
        if (content || title) {
            checkAllWord.map((item, i) => {
                let itemWord = item.word;//错误词
                let replaceHtml = '<font text="sensitive" class="word"><strong class="word">' + itemWord + '</strong></font>';
                let reg = new RegExp(`(${item.word})`, "g");
                content = content.replace(reg, replaceHtml);
                title = title.replace(reg, replaceHtml);
            });
        }
        return (
            <div className={'details_content'} style={{height: height}}>
                {/*标题*/}
                <Scrollbars autoHide autoHeightMax={height}>
                    <div style={{padding: '0 10px'}}>
                        <div
                            style={{
                                ...publicStyle,
                                fontSize: '22px',
                                textAlign: 'left',
                                color: 'rgba(0, 0, 0, 0.85)',
                            }}
                            dangerouslySetInnerHTML={{__html: title}}
                        >
                        </div>
                        {/*副标题*/}
                        <div
                            style={{
                                fontSize: '18px',
                                color: 'rgba(0, 0, 0, 0.85)',
                                ...publicStyle,
                            }}
                            dangerouslySetInnerHTML={{__html: this.state.mainBody.ftitle}}
                        >
                        </div>
                        {/*摘要*/}
                        <div style={{
                            fontSize: '14px',
                            color: 'rgba(0, 0, 0, 0.45)',
                            ...publicStyle,
                        }}
                             dangerouslySetInnerHTML={{__html: this.state.mainBody.summary}}
                        >
                        </div>
                        {/*正文*/}
                        <div
                            style={{
                                fontSize: '14px',
                                color: 'rgba(0, 0, 0, 0.65)',
                                ...publicStyle,
                            }}
                            dangerouslySetInnerHTML={{__html: content}}
                        >
                        </div>
                    </div>
                    <style>
                        {`
                        font.word {
                        color: #fff;
                        background-color: red;
                        cursor: pointer;
                        }
                    `}
                    </style>
                </Scrollbars>

            </div>
        )
    };
    // 附件部分
    renderLeft = () => {
        let {attach} = this.state;
        // console.log('attach---------',attach);
        return (
            <div style={{
                position: 'fixed',
                left: 0,
                top: 95,
                background: '#fff',
                width: 320,
                boxShadow: '0px 0px 5px #d9d3d3',
                borderRadius: '3px',
            }}>
                <div style={{
                    borderBottom: '1px solid #ccc',
                    height: 48,
                    fontSize: '14px',
                    color: 'rgba(0, 0, 0, 0.65)',
                    padding: '14px 16px',
                    fontWeight: 'bolder'
                }}>附件
                </div>
                <Scrollbars autoHeight autoHeightMax={683} autoHide>
                    <div style={{paddingBottom:14}}>
                        {attach && attach.length ?
                            attach.map(item => {
                                return (
                                    <div className={'accessory_item'} key={item.md5}>
                                        <img src={item.icon} style={{marginRight: 10, width: 32, height: 32, objectFit: 'cover'}}/>
                                        <span className={'accessory_title'} title={item.name}>{item.name}</span>
                                        <span style={{
                                            color: this.themeBgColor,
                                            cursor: 'pointer',
                                            marginRight: '14px'
                                        }}
                                              onClick={() => {
                                                  this.preview(item);
                                              }}
                                        >预览</span>
                                        <span style={{color: this.themeBgColor, cursor: 'pointer'}} onClick={() => {
                                            this.downloadFile(item)
                                        }}>下载</span>
                                    </div>
                                )
                            })
                            : <Empty style={{padding: '12px 0px'}}/>}
                    </div>
                </Scrollbars>
                <div style={{marginTop:10}}/>
            </div>
        )
    };
    // 历史记录部分
    renderRight = () => {
        return (
            <div style={{position: 'fixed', right: 0, top: 55, background: '#fff', width: 100}}>
                <HistoryList
                    isContentDetail={'contentSecurityCenter'}
                    // diffOnClick={() => {
                    //     window.open(`#/view/htmldiff/htmldiff/history/website/${this.urlParams.checkUrl.id}`)
                    // }}
                    itemComponentClick={(editor, item) => {
                        console.log('editor, item---------------', editor, item);
                        // if (item.type == 'Story') {
                        //     let url = `/cm-sites-pms/story/show?storyId=${item.id}`;
                        //     this.getHistoryContent(url);
                        // };
                        this.setState({
                            mainBody: {
                                ...this.state.mainBody,
                                content: item.content,
                                title: item.title,
                            },
                        })
                    }}
                    itemComponent={HistoryItem} title={"历史记录"}
                    visible={true}
                    data={this.state.list}/>
            </div>
        )
    };
    // 根据类型和id查询稿件
    // getHistoryContent = (url) => {
    //     this.request({
    //         url,
    //         callBack: (res) => {
    //             console.log('999999999999999999999999999999',res,url)
    //         }
    //     });
    // };
    // 获取数据
    getItemDataSource = (key) => {
        let params = {
            key: key,
        };
        this.request({
            url: "/cm-sites-sys/contentCheck/getAllCheckLogByKey",
            body: params,
            callBack: (res) => {
                if(res&&res.length){
                    let checkAllWord = [];
                    if (res) {
                        checkAllWord = res[0].allWord;
                    } else {
                        message.error("数据获取失败！");
                    }
                    this.setState({checkAllWord}, () => {
                        this.hoverText()
                    })
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };

    // 历史记录
    getHistoryData(editorId) {
        if (editorId) {
            let url = "/cm-sites-pms/website/news/getWebNewsHistory";
            let body = {webNewsId: editorId};
            // console.log("this.dataType:   ", this.dataType, this.dataType === "story");
            if (this.state.dataType === "story") {
                url = "/cm-sites-pms/story/getStoryHistory";
                body = {storyId: editorId};
            }
            if(this.state.dataType === "rmapp"){
                url = "/cm-sites-mmp/mf/getMediaFusionHistory";
                body = {mediaFusionId: editorId};
            }
            this.request({
                url,
                body,
                callBack: (list) => {
                    if (list && list.length) {
                        this.setState({list});
                        this.setState({
                            mainBody: {
                                ...this.state.mainBody,
                                content: list.content,
                                title: list.title
                            },
                        });
                        this.getContent();
                    } /*else {
                        if (this.urlParams && this.urlParams.checkUrl && this.urlParams.checkUrl.id != editorId) {
                            this.getHistoryData(this.urlParams.checkUrl.id)
                        }
                    }*/
                }
            })
        }
    }

    // 获取
    getContent = () => {
        let {checkUrl} = this.state;
        let that = this;
        this.request({
            url: checkUrl,
            callBack: (res) => {
                let content = "";
                let title = "";
                let ftitle = "";
                let summary = "";
                let attach = [];
                if (res) {
                    if (res.content || res.title) {
                        content = res.content;
                        title = res.title;
                    }
                    if (res.variableFields && (res.variableFields.ftitle || res.variableFields.summary)) {
                        ftitle = res.variableFields.ftitle;
                        summary = res.variableFields.summary;
                    }
                    attach = res.attach ? res.attach : [];
                }
                this.setState({
                    mainBody: {content, title, ftitle, summary},
                    attach
                },()=>{
                    // 附件图标
                    this.attachIcon();
                    $('img').click(function(){
                        if($(this).attr('video-src')){
                            let videoPath = $(this).attr('video-src');
                            if (videoPath && videoPath.length) {
                                that.setState({
                                    videoPath: videoPath
                                }, () => {
                                    that.detailDialog.show()
                                });
                            }
                        }
                    })
                });
            }
        })
    };
    getExt = (name) => {
        if(!name || !name.includes('.')) return "";
        return name.split('.').at(-1).toLowerCase();
    };
    getIcon = async ({ext,url=""}) => {
        let fileConfig = "default";
        for (let key in extIconList) {
            if (extIconList[key].ext.includes(ext)) {
                fileConfig = key
            }
        }
        if (extIconList[fileConfig].icon) {
            return extIconList[fileConfig].icon
        }
        if (extIconList[fileConfig].getIconFun && url) {
            return await this[extIconList[fileConfig].getIconFun](url)
        }
        return ""
    };
    // 附件图标
    attachIcon = () => {
        if (!(this.state.attach && this.state.attach.length)) return false;
        this.state.attach.forEach(async item => {
            let ext = this.getExt(item.name);
            item.icon = await this.getIcon({ext, url: item.url});
            this.setState({})
        });
        this.setState({})
    };
    // 附件图标配置项内容
    iconConfig = () => {
        extIconList.pdfs.icon = this.sysConfigGetValueByKey('icon_pdf_path', '/storage/C9EE69F38A7FD2B17A1E9D0BE2C5AD7A');
        extIconList.words.icon = this.sysConfigGetValueByKey('icon_word_path', '/storage/D472D1C574F0289E5C8731F8DD81AFF2');
        extIconList.txts.icon = this.sysConfigGetValueByKey('icon_txt_path', '/storage/252FB9797052C9D7DAC72E01B732E615');
        extIconList.excels.icon = this.sysConfigGetValueByKey('icon_excel_path', '/storage/EB84D79649B71985703DAB508BA18023');
        extIconList.zips.icon = this.sysConfigGetValueByKey('icon_zip_path', '/storage/2B63DF6CECDC9A70A3D7C31C86319906');
        extIconList.ppts.icon = this.sysConfigGetValueByKey('icon_ppt_path', '/storage/4123F1C5885E8E86706AEBD4B1778A7D');
        extIconList.audios.icon = this.sysConfigGetValueByKey('icon_audio_path', '/storage/9D74B50D3E3967F15C39C0F15560B56F');
    };
    imgIcon = (url) => {
        return url
    };
    //视频图片接口
    videoIcon = (url) => {
        return new Promise(((resolve, reject) => {
            if(url) {
                let params = {url: url};
                this.request({
                    url:'/storage/getStorageFileByUrl',
                    body: params,
                    callBack: (res) => {
                        if (res) {
                            this.state.attach.map(item => {
                                if (item.md5 === res.md5) {
                                    item.data = res
                                }
                            })
                        }
                        if (res && res.thumbnailsPlayPath) {
                            resolve(res.thumbnailsPlayPath)
                        } else {
                            resolve("")
                        }
                    },
                    errorCallBack: (e) => {
                        resolve("")
                    }
                })
            } else {
                resolve("")
            }
        }));
    };
    // 预览
    preview(item){
        let urlHost = window.location.origin;
        if (urlHost.indexOf('127.0.0.1') > -1) {
            urlHost = 'http://192.168.120.50:9241'
        }
        let preivewUrl = encodeURIComponent(base64Encode(`${urlHost}${item.data && item.data.mp4Path ? item.data.mp4Path : item.url}?fullfilename=${item.name}`));
        let officeViewUrl = urlHost + '/kkfileview/onlinePreview' + "?url=" + preivewUrl;
        window.open(`${officeViewUrl}`, '_blank');
    }

    // 下载
    downloadFile = (item) => {
        let {downloadFileData} = this.state;
        if (!(downloadFileData || downloadFileData.length)) {
            message.error('请选择要下载的附件!');
            return;
        }
        let path = item.url;
        path = path + '?download=1';
        window.open(`${path}`, '_blank');
    };

    // 正文悬浮
    hoverText() {
        let details_content = $jq(".details_content");
        let that = this;
        details_content.on('mouseover', ".word", function (e) {
            let clientX = e.clientX;
            let clientY = e.clientY;
            var text = $jq(this).text();
            that.state.checkAllWord.map((item, i) => {
                let itemWord = item.word;//错误词
                if (itemWord == text) {
                    let itemCorrectWord = item.correctWord;//正确词
                    let currWord;
                    if (item.category === "SENSITIVE") {
                        currWord = '“' + itemWord + '”建议修改为：“' + itemCorrectWord + '”';
                    } else {
                        currWord = '“' + itemWord + '”建议删除';
                    }
                    setTimeout(() => {
                        $jq('.itemCorrectWord').remove();
                        let dome = '<div style="z-index:99999;position: absolute;left:' + clientX + 'px;top:' + clientY + 'px  " class="itemCorrectWord">' +
                            '<div style="width: 0px;height: 0px;border-left: 5px solid transparent;border-bottom:  10px solid #1a62bb;border-right:  5px solid transparent;position: relative;margin: auto"></div>' +
                            '<div style="color:#fff;font-size:16px;background:#1a62bb;border-radius: 5px;padding:5px 10px;">' + currWord + '</div></div>';
                        $jq(".details_content").append(dome);
                        let width = $jq('.itemCorrectWord').width();
                        let newClientX = clientX - width / 2;
                        $jq('.itemCorrectWord').css({
                            position: 'absolute', left: newClientX + 'px',
                            top: clientY + 'px',
                        })
                    }, 100);
                    e.preventDefault();
                }
            });
        });
        details_content.on('mouseout', ".itemCorrectWord", function (e) {
            $jq(this).remove()
        });
        details_content.on('mouseout', ".word", function (e) {
            $jq('.itemCorrectWord').remove()
        });
    }
}

function base64Encode(str) {
    // 对字符串进行编码
    let encode = encodeURI(str);
    // 对编码的字符串转化base64
    let base64 = btoa(encode);
    return base64;
}

class HistoryItem extends Component {
    static defaultProps = {
        style: {},
        className: "historyItem",
        onClick: () => {
        }
    };

    render() {
        let {item} = this.props;
        return <div onClick={() => {
            this.props.onClick()
        }} className={this.props.className} style={{
            borderLeft: '3px solid #24B481',
            borderRadius: 3,
            padding: 10,

            borderColor: this.props.color, ...this.props.style
        }}>
            <table cellPadding={0} cellSpacing={0} border={0} width={"100%"} height={"100%"}>
                <tbody>
                <tr>
                    <td valign={"middle"}>
                        <div title={item.title} className={"plan-pointer showTwoText"}
                             style={{marginRight: 20, paddingLeft: 5}}>
                            {item.operator ? item.operator : "错误数据"}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td valign={"middle"}>
                        <div className={"plan-pointer"} style={{
                            marginRight: 20,
                            paddingLeft: 5,
                            color: "#ada4a4"
                        }}>{moment(item.createTime).format("yyyy-MM-DD HH:mm:ss")}</div>
                    </td>
                </tr>
                </tbody>
            </table>
            <style>{`
                .historyItem:hover{
                    background: #ccd9eb !important
                }
                 .historyItem{
                              height:80px !important
                            }
            `}</style>
        </div>
    }
}